export function getLogoUrl() {
  var temporaryElement = document.createElement("div")
  temporaryElement.className = "logo-background-image"
  document.body.appendChild(temporaryElement)
  let backgroundImage = getComputedStyle(temporaryElement).backgroundImage
  document.body.removeChild(temporaryElement)

  var result = backgroundImage.match(/url[\("']*([^"')]*)["'\)]*\)/i)

  let url = result[1]
  return url
}
